<template>
  <v-color-picker
    v-model="color"
    mode="hexa"
    :hide-mode-switch="true"
    :hide-inputs="false"
    :swatches="swatches"
    show-swatches
    class="mx-auto"
  ></v-color-picker>
</template>

<script>
export default {
  props: ['value'],
  data () {
    return {
      color: '#000000',
      swatches: [
        ['#FF0000', '#AA0000', '#550000'],
        ['#FFFF00', '#AAAA00', '#555500'],
        ['#00FF00', '#00AA00', '#005500'],
        ['#00FFFF', '#00AAAA', '#005555'],
        ['#0000FF', '#0000AA', '#000055']
      ]
    }
  },
  created () {
    this.color = this.value
  },
  watch: {
    value (value) {
      if (value !== this.color) {
        this.color = value
      }
    },
    color (color) {
      this.$emit('input', color)
    }
  }
}
</script>
